import React, { FC } from "react";

import FilterSizesAggregatedWeb from "./filterSizesAggregatedWeb";
import { GeneralFacet, SizeFacet } from "../../types";

type Props = {
  filter: GeneralFacet & SizeFacet;
};

const FilterSizesWeb: FC<Props> = ({ filter }) => (
  <FilterSizesAggregatedWeb filter={filter as any} />
);

export default FilterSizesWeb;
